import { useEffect, useState } from 'react'
import { useUserMap } from '../../hooks/useUsers'
import { useEphemeral } from '../../state/ephemeral'

const EMPTY: Record<string, number> = {}

export function typingLabel(names: string[]): string {
  if (names.length === 0) return ''
  if (names.length === 1) return `${names[0]} is typing…`
  if (names.length === 2) return `${names[0]} and ${names[1]} are typing…`
  return 'Several people are typing…'
}

export function TypingIndicator({ channelId }: { channelId: string }) {
  const typing = useEphemeral((s) => s.typing[channelId] ?? EMPTY)
  const users = useUserMap()
  const [now, setNow] = useState(() => Date.now())
  const active = Object.entries(typing).filter(([, expires]) => expires > now)

  // Tick while someone is typing so entries expire after 5 s.
  useEffect(() => {
    if (Object.keys(typing).length === 0) return
    const timer = setInterval(() => {
      setNow(Date.now())
      useEphemeral.getState().pruneTyping()
    }, 1000)
    return () => clearInterval(timer)
  }, [typing])

  const names = active.map(([id]) => users.get(id)?.displayName.split(' ')[0] ?? 'Someone')
  return (
    <div className="typing-indicator" aria-live="polite">
      {names.length ? (
        <>
          <span className="typing-dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          {typingLabel(names)}
        </>
      ) : null}
    </div>
  )
}
